import React, { useState, useEffect } from "react";
import { Policy } from "./components/policy";
import { Footer } from "./components/footer";

import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const PolicyCompo = () => {

  return (
    <>
      <Policy />
      <Footer />
    </>
  );
};

export default PolicyCompo;
